// LucideIcon type is reserved for future use in playground registry extensions

export type GlassCardSample = {
  id: string;
  title: string;
  description: string;
  iconName: "Sparkles" | "Shield" | "Globe";
  bgClass?: string;
  hoverClass?: string;
  extraClassName?: string;
  descriptionClassName?: string;
};

export type SolidBlockSample = {
  id: string;
  title: string;
  description: string;
  bgClass?: string;
  titleClassName?: string;
};

export type BannerSample = {
  id: string;
  badgeText: string;
  description: string;
  badgeColor: string;
  shadowClass: string;
  interactive: boolean;
  hasIcon: boolean;
};

export const glassCardSamples: GlassCardSample[] = [
  {
    id: "C.1.1",
    title: "基础白卡片",
    description: "默认底色，无抬升动画，无点击交互。",
    iconName: "Sparkles",
    extraClassName: "flex flex-col",
    descriptionClassName: "text-sm font-bold text-zinc-700",
  },
  {
    id: "C.1.2",
    title: "静态点击卡",
    description: "无位置抬升，依靠自身变浓反馈，点击压塌阴影。",
    iconName: "Shield",
    bgClass: "bg-[#8B5CF6]/75",
    hoverClass: "hover:bg-[#8B5CF6]/95",
    extraClassName: "flex flex-col text-white cursor-pointer",
    descriptionClassName: "text-sm font-bold text-white/90",
  },
  {
    id: "C.1.3",
    title: "抬升点击卡",
    description: "悬停左上浮起（拉长阴影），带核心跳转属性，点击下沉。",
    iconName: "Globe",
    bgClass: "bg-[#A3E635]/75",
    hoverClass: "hover:bg-[#A3E635]/95",
    extraClassName: "flex flex-col text-black cursor-pointer hover:-translate-x-1 hover:-translate-y-1 hover:shadow-[10px_10px_0px_0px_rgba(0,0,0,1)] transition-all",
    descriptionClassName: "text-sm font-bold text-zinc-700",
  },
  {
    id: "C.1.4",
    title: "装饰抬升卡",
    description: "仅有悬停时左上方浮起效果用于装饰，无点击反馈（无压塌）。",
    iconName: "Sparkles",
    bgClass: "bg-white/75",
    hoverClass: "hover:bg-white/95",
    extraClassName: "flex flex-col text-black hover:-translate-x-1 hover:-translate-y-1 hover:shadow-[10px_10px_0px_0px_rgba(0,0,0,1)] transition-all",
    descriptionClassName: "text-sm font-bold text-zinc-700",
  },
];

export const solidBlockSamples: SolidBlockSample[] = [
  {
    id: "C.2.1",
    title: "深黑色底座",
    description: "标准纯黑底座材质，内部可再承载其它轻量级组件，通过强对比形成厚重感边界。",
    titleClassName: "text-xl font-black uppercase mb-4 text-[#A3E635]",
  },
  {
    id: "C.2.2",
    title: "品牌色实色底座",
    description: "6 绝不仅限于深黑。背景色必须从品牌的 9 种标准色词内选取：green / blue / purple / teal / orange / yellow / pink / red / indigo。只要不透底，它就具备极强的板块冲击力。",
    bgClass: "bg-[#8B5CF6] text-white",
    titleClassName: "text-xl font-black uppercase mb-4 text-black bg-[#A3E635] inline-block px-2",
  },
];

export const bannerSamples: BannerSample[] = [
  {
    id: "C.3.1",
    badgeText: "静态横幅",
    description: "单纯的说明性横幅容器本身。没有提供全局鼠标悬浮状态，安静地提供信息。",
    badgeColor: "bg-black",
    shadowClass: "shadow-[2px_2px_0px_0px_rgba(163,230,53,1)]",
    interactive: false,
    hasIcon: false,
  },
  {
    id: "C.3.2",
    badgeText: "交互横幅",
    description: "带跳转目的的横幅模板容器本身。悬停时主体仅发生玻璃背景浓度厚实的变化。",
    badgeColor: "bg-[#3B82F6]",
    shadowClass: "shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]",
    interactive: true,
    hasIcon: true,
  },
];
